import React from 'react';
import { COLORS } from '../../../styles/tokens';

// Pille-bryter (designets «Tonn / Sekker» og «Meg selv / Organisasjon»).
export default function SegmentedControl({ options, value, onChange, ariaLabel, fill }) {
  return (
    <div role="group" aria-label={ariaLabel} style={{ display: 'flex', background: COLORS.surfaceHover, borderRadius: 99, padding: 4, alignItems: 'center' }}>
      {options.map(o => {
        const active = o.value === value;
        return (
          <button
            key={String(o.value)}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(o.value)}
            style={{
              flex: fill ? 1 : 'none', border: 'none', cursor: 'pointer', borderRadius: 99,
              padding: fill ? '10px 0' : '11px 18px', fontSize: 14, fontWeight: active ? 700 : 600,
              background: active ? COLORS.brandPanel : 'transparent',
              color: active ? '#fff' : COLORS.textMid,
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
